/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tournament_Register_Checkin_BtnInputs */



/**
* | output |
* | --- |
* | "Register & Check In" |
*
* @param {Tournament_Register_Checkin_BtnInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const tournament_register_checkin_btn = /** @type {((inputs?: Tournament_Register_Checkin_BtnInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tournament_Register_Checkin_BtnInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("S'inscrire et pointer")
	if (locale === "es") return /** @type {LocalizedString} */ ("Inscribirse y hacer check-in")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Inscrever-se e fazer check-in")
	if (locale === "it") return /** @type {LocalizedString} */ ("Iscriviti e fai check-in")
	return /** @type {LocalizedString} */ ("Register & Check In")
});